import { useStore } from '@/store'
import { useCallback } from 'react'

export default function useReceive() {
  const { state, setState } = useStore()
  const receiveModalOpen = state.receiveModalOpen
  const rewardViewList = state.rewardViewList
  const rewardHideText = state.rewardHideText

  const openReceiveModal = useCallback(
    (rewardList: RewardViewList, hideText = false) => {
      setState({
        rewardViewList: rewardList,
        receiveModalOpen: true,
        rewardHideText: hideText,
      })
    },
    []
  )

  const closeReceiveModal = useCallback(() => {
    setState({
      receiveModalOpen: false,
      rewardViewList: [],
      rewardHideText: false,
    })
  }, [])

  return {
    receiveModalOpen,
    rewardViewList,
    rewardHideText,
    openReceiveModal,
    closeReceiveModal,
  }
}
